if (typeof JW === 'undefined') JW = {};
JW.SiocLiveRoom = function ($, sioc, socket, meta)
{
    var State = JW.State;

    var _pri = {};
    var publ = {};

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    _pri.cname = 'SIOCROOM' + meta.room_id_to;
    _pri.opts = {
        dbg_lvl: 1
    };

    _pri.colors = [
        '#e21400', '#91580f', '#f8a700', '#f78b00',
        '#58dc00', '#287b00', '#a8f07a', '#4ae8c4',
        '#3b88eb', '#3824aa', '#a700ff', '#d300e7'
    ];

    _pri.sioc      = sioc;
    _pri.socket    = socket;

    _pri.uid     = '';
    _pri.inited  = false;
    _pri.deleted = false;
    _pri.page    = null;
    _pri.$xch    = null;

    _pri.room_id          = meta.room_id_to;
    _pri.display_name     = meta.display_name;

    publ.socket_ids_map   = {};
    publ.joined           = false;

    _pri.init = function()
    {
        _pri.dbg('******** init()');
        _pri.dbg('    opts.env_int:', _pri.opts.env_int);

        if (_pri.inited)
        {
            _pri.dbg('!!! already inited!');
            return;
        }

        _pri.inited = true;
        _pri.$doc   = $(document);
        _pri.page   = JW.Page;
        _pri.uid    = JW.Page.getUId();
        _pri.$xch   = $('#xch');

        _pri.meta = {
            room_id: _pri.room_id
        };

        _pri.initEvs();
        _pri.joinRoom();
    };

    //################################################################################################################################
    //################################################################################################################################
    //################################################################################################################################

    publ.leaveRoom = function()
    {
        _pri.leaveRoom();
    };

    //################################################################################################################################
    //################################################################################################################################
    //################################################################################################################################

    _pri.initEvs = function()
    {
        _pri.page.on('sio:on_connect',    _pri.pageOnConnect);
        _pri.page.on('sio:on_auth',       _pri.pageOnAuth);
        _pri.page.on('sio:on_disconnect', _pri.pageOnDisconnect);
    };

    _pri.offEvs = function()
    {
        _pri.page.off('sio:on_connect',    _pri.pageOnConnect);
        _pri.page.off('sio:on_auth',       _pri.pageOnAuth);
        _pri.page.off('sio:on_disconnect', _pri.pageOnDisconnect);
    };

    _pri.pageOnConnect = function(e, o)
    {
        // _pri.dbg('*** sio:on_connect o:', o);
    };

    _pri.pageOnAuth = function(e, o)
    {
        _pri.dbg('*** sio:on_auth o:', o, 'deleted:', _pri.deleted);
        _pri.joinRoom();
    };

    _pri.pageOnDisconnect = function(e, o)
    {
        // _pri.dbg('*** sio:on_disconnect o:', o);
        _pri.roomLeft(o);
    };

    publ.onUserJoined = function(meta)
    {
        // _pri.dbg('### on user_joined', meta);
        if (publ.joined)
        {
            _pri.addUser(meta);
        }
    };

    publ.onUserLeft = function(meta)
    {
        // _pri.dbg('*** onUserLeft()', meta);
        if (publ.joined)
        {
            _pri.remUser(meta);
        }
    };

    _pri.joinRoom = function()
    {
        _pri.dbg('*** joinRoom()');

        if (_pri.sioc.isValidConn() && !publ.joined)
        {
            _pri.socket.emit('room_join', {room_id_to: _pri.room_id, display_name: _pri.display_name}, _pri.ackJoinRoom);
        }
    };

    _pri.ackJoinRoom = function(meta)
    {
        _pri.dbg('*** ackJoinRoom()', meta);
        if (meta.state === State.STATE_OK)
        {
            // _pri.dbg('    err === 0');
            // _pri.dbg('    socket.user_name:', _pri.socket.user_name);

            if (!publ.joined)
            {
                // _pri.dbg('    2');
                publ.joined = true;
            }

            _pri.setUserList(meta.user_list);

            if (typeof meta.is_adm !== 'undefined' && meta.is_adm === true)
            {
                _pri.page.trigger('live_room:room_joined_adm', meta);
            }
        }
        else
        {
            _pri.dbgR('!!! ackJoinRoom() got err, meta:', meta);
            _pri.sioc.onErr(meta);
        }
    };

    _pri.leaveRoom = function()
    {
        _pri.dbg('*** leaveRoom()');
        if (_pri.isValidRoomConn())
        {
            _pri.socket.emit('room_leave', _pri.room_id, _pri.ackLeaveRoom);
        }
    };

    _pri.ackLeaveRoom = function(meta)
    {
        _pri.dbg('### ackLeaveRoom()', meta);
        if (meta.err === _pri.sioc.ERR_NONE)
        {
            _pri.roomLeft(meta);
        }
        else
        {
            _pri.dbg(meta.err_msgs);
        }
    };

    _pri.roomLeft = function(meta)
    {
        // _pri.dbg('*** roomLeft()');

        publ.joined = false;
        _pri.setUserList({});
    };

    publ.deleteRoom = function()
    {
        _pri.dbgY('*** deleteRoom()');

        _pri.leaveRoom();
        _pri.roomLeft();

        _pri.offEvs();
        _pri.deleted = true;
        delete publ;
        delete _pri;
    };

    //################################################################################################################################
    //################################################################################################################################
    //################################################################################################################################

    _pri.setUserList = function(o)
    {
        publ.socket_ids_map = {};
        for (var p in o)
        {
            _pri.addUser({user_name: o[p], socket_id: p});
        }
    };

    _pri.addUser = function(o)
    {
        publ.socket_ids_map[o.socket_id] = o.user_name;
    };

    _pri.remUser = function(o)
    {
        delete publ.socket_ids_map[o.socket_id];
    };

    _pri.isValidRoomConn = function()
    {
        return (publ.joined && _pri.sioc.isValidConn());
    };

    _pri.getMeta = function(o)
    {
        return $.extend(_pri.sioc.getMeta(), _pri.meta, o || {});
    };

    _pri.extend();

    _pri.init();
    // expose public methods
    return publ;
};
